import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    atual: null
  },

  getters: {
    atual: (state) => {
      return state.atual
    },
    bloqueiaOsInterna: (state) => {
      if (!state.atual) {
        return false
      }

      return state.atual.st_bloqueia_os_interna === 'S'
    }
  },

  actions: {
    loadFromLocalStorage: ({ commit }) => {
      if (!localStorage.empresaAtual) {
        return
      }

      try {
        commit('setAtual', JSON.parse(localStorage.empresaAtual))
      } catch (error) {
        localStorage.removeItem('empresaAtual')
      }
    },

    async fetchAtual({ commit }) {
      try {
        const response = await api.get('empresa')

        commit('setAtual', response.data)

        return response
      } catch (error) {
        console.log(error)
      }
    }
  },

  mutations: {
    setAtual(state, empresa) {
      if (!empresa) {
        localStorage.removeItem('empresaAtual')
        state.atual = null
        return
      }

      localStorage.empresaAtual = JSON.stringify(empresa)
      state.atual = empresa
    },

    unsetAtual(state) {
      localStorage.removeItem('empresaAtual')
      state.atual = null
    }
  }
}
